import React, { useMemo } from 'react';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import { Widget } from '../widget/widget';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { classes } from './fixed-payment-field-wut.st.css';
import { useConfig } from '../../contexts/config-context';
import { RequiredIndicator } from '@wix/ambassador-forms-v4-form/types';
import { formatCurrency } from '../../utils/format-currency';
export const FixedPaymentFieldWUT = _ref => {
  var _paymentValidation$fi;
  let {
    id,
    label,
    hideLabel = false,
    required = false,
    error,
    description,
    validation,
    FieldLayout,
    widgetHtml,
    widgetEnabled
  } = _ref;
  const {
    labelId,
    inputId,
    descriptionId
  } = useFieldAttributes(id, error, description);
  const {
    currency,
    regionalFormat
  } = useConfig();
  const paymentValidation = useMemo(() => {
    var _validation$predefine;
    return validation == null || (_validation$predefine = validation.predefined) == null || (_validation$predefine = _validation$predefine.paymentOptions) == null || (_validation$predefine = _validation$predefine.products) == null ? void 0 : _validation$predefine[0];
  }, [validation]);
  const fixedPaymentValue = paymentValidation == null || (_paymentValidation$fi = paymentValidation.fixedPriceOptions) == null ? void 0 : _paymentValidation$fi.price;
  const formattedValue = formatCurrency({
    amount: fixedPaymentValue,
    currency: currency == null ? void 0 : currency.code,
    locale: regionalFormat
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: RequiredIndicator.NONE
    }),
    renderInput: () => widgetHtml && widgetEnabled ? /*#__PURE__*/React.createElement(Widget, {
      fieldId: id,
      widgetHtml: widgetHtml,
      onChange: () => {},
      value: null
    }) : /*#__PURE__*/React.createElement(Text, {
      className: classes.text,
      id: inputId,
      "data-hook": "fixed-payment-value",
      "aria-hidden": "false"
    }, formattedValue),
    renderDescription: () => /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    })
  });
};
//# sourceMappingURL=fixed-payment-field-wut.js.map